export default class ViewModelCore {
    constructor(){
        this.TempId = new Date().getTime()
    }
}